export default __webpack_public_path__ + "static/img/apple-store-badge.fbf9291.png";